// extracted by mini-css-extract-plugin
module.exports = {"skillContainer":"skill-module--skillContainer--_CbkJ","techLogo":"skill-module--techLogo--1YJ5h","description":"skill-module--description--6zqkD"};